import React from "react";
import PropTypes from "prop-types";
import { Row, Col, Image } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { LabelName } from "../styles";

function brandLabelOf(product) {
  const b = product?.brand;
  if (!b) return "";
  if (typeof b === "string") return b;
  return b.label || b.name || "";
}
import InputCardQuantity from "../../../../components/InputCardQuantity";
import { IoMdClose } from "react-icons/io";
import { trackClick } from "../../../../utils/gtm";
import { tagIdFromLegacySuffix } from "../../../../utils/marketplaceTagIds";
import { useScreenTracking } from "../../../../hooks/useScreenTracking";

export default function CartItem({
  product,
  quantity,
  priceValue,
  index,
  hasProblem,
  hasQuantityError,
  onRemove,
  onQuantityError,
  onQuantityValid,
}) {
  const navigate = useNavigate();
  const screenName = useScreenTracking();

  const handleThumbClick = () => {
    trackClick({
      title: "clicar-thumb-pdp",
      contentType: "carrinho",
      screenName,
      tagId: tagIdFromLegacySuffix("15"),
    });
    navigate(`/loja/product/${product.uuid}`);
  };

  return (
    <Row
      className={hasProblem ? "has-problem" : ""}
      style={{
        border: hasQuantityError ? "1px solid #96143C" : "",
        borderRadius: "10px",
      }}
    >
      <Col className="col-4">
        <div
          onClick={handleThumbClick}
          style={{ cursor: "pointer" }}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              handleThumbClick();
            }
          }}
        >
          <Image
            className="block-example border border-white"
            thumbnail={true}
            src={product.image}
            alt={product.short_description || ""}
          />
        </div>
      </Col>
      <Col className="col-8">
        <div className="d-flex justify-content-between align-items-center my-3">
          <LabelName className="font-wl-500 text-sm m-0">
            {brandLabelOf(product) || product.seller}
          </LabelName>
          <button
            type="button"
            aria-label={`Remover ${product.short_description || "item"}`}
            onClick={() => onRemove(product.sku, product, index)}
            className="border-0 bg-white"
          >
            <IoMdClose size={20} />
          </button>
        </div>
        <p className="font-wl-400 text-sm color-wl color-opacty-60">
          {product.short_description}
        </p>
        {hasQuantityError && (
          <p
            className="font-wl-400 text-sm"
            style={{ color: "red", fontWeight: "bold" }}
            role="alert"
          >
            Item indisponível
          </p>
        )}
        <InputCardQuantity
          amount={quantity}
          value={priceValue}
          uuid={product.uuid}
          sku={product.sku}
          maxQty={product.limit_per_purchase}
          onQuantityError={onQuantityError}
          onQuantityValid={onQuantityValid}
        />
      </Col>
    </Row>
  );
}

CartItem.propTypes = {
  product: PropTypes.shape({
    uuid: PropTypes.string.isRequired,
    sku: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired,
    short_description: PropTypes.string,
    seller: PropTypes.string,
    limit_per_purchase: PropTypes.number,
  }).isRequired,
  quantity: PropTypes.number.isRequired,
  priceValue: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  hasProblem: PropTypes.bool,
  hasQuantityError: PropTypes.bool,
  onRemove: PropTypes.func.isRequired,
  onQuantityError: PropTypes.func,
  onQuantityValid: PropTypes.func,
};
